import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-recurrent-implantation-failure',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './recurrent-implantation-failure.component.html',
  styleUrl: './recurrent-implantation-failure.component.scss'
})
export class RecurrentImplantationFailureComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/recurrent-implantation-failure",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);




    this.titleService.setTitle('Recurrent Implantation Failure Treatment in Kannur | Ncare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Struggling with repeated IVF failures? Ncare IVF Centre in Kannur offers expert diagnosis and personalized treatment for Recurrent Implantation Failure to improve your pregnancy chances.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Recurrent Implantation Failure, Recurrent Implantation Failure Treatment, Recurrent Implantation Failure Treatment in kannur'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Recurrent Implantation Failure Treatment in Kannur | Ncare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Struggling with repeated IVF failures? Ncare IVF Centre in Kannur offers expert diagnosis and personalized treatment for Recurrent Implantation Failure to improve your pregnancy chances.'
    });
  }

  contactus() {
    this.route.navigate(['/contact-us']);
  }

}
